import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import couterpart from 'counterpart';
import DatePicker from 'react-datepicker';
import { ToastsContainer, ToastsStore } from 'react-toasts';
import Spinner from 'react-spinner-material';

import { FaFilter } from 'react-icons/fa';
import { MdImportExport } from 'react-icons/md';
import Dialog from 'react-bootstrap-dialog';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

import ReactTable from "react-table";
import "react-table/react-table.css";

import { Multiselect } from 'multiselect-react-dropdown';

import "react-table/react-table.css";
import "../css/style.css";

import { DATA_TYPE_SHIPPING, LOI_CAT_KHAC_LIST, LOI_THO_LIST, LOI_XI_LIST, WO_CHUA_SHIP, WO_DA_SHIP, WO_TOBE_FIXE_ALL, WO_TOBE_FIXE_LOITHO, WO_TOBE_FIXE_LOIXI, WO_TOBE_FIXE_LOI_CATKHAC } from '../constants';

import MenuComponent2 from './MenuComponent2';
// import ShipProductListView from './ShipProductListView';
import WorkOrderUtil from '../utilities/WorkOrderUtil';
import UserDataService from '../services/UserDataService';
import WorkOrderDataService from '../services/WorkOrderDataService';
import MasterDataService from '../services/MasterDataService';
import AuthenticationService from '../services/AuthenticationService';
import ItemDataService from '../services/ItemDataService';
import { ICON_COLOR } from '../icon';
import queryString, { parse } from 'query-string'
import DataUtil from '../utilities/DataUtil';

class ShipProductList extends Component {
  constructor() {
    super();

    const numOfMonths = 24;
    let fromDate = new Date(new Date().getTime() - numOfMonths * 30 * 24 * 60 * 60 * 1000 * 3);//1 month
    fromDate = WorkOrderUtil.convertToyyyyMMddhhmmString(fromDate);
    let toDate = new Date();
    toDate = WorkOrderUtil.convertToyyyyMMddhhmmString(toDate);

    this.state = {
      filterGhiThiep: 0,
      spinnerVisible: false,
      allStatus: [],
      fromDate: fromDate,
      toDate: toDate,
      fromDeadlineDate: toDate,
      toDeadlineDate: toDate,
      deadline: '0',
      status: '0',
      country: null,
      customer: null,
      orderNo: null,
      woStatus: 0,
      woSubStatus: 0,
      errorFilter: 0,
      workOrders: [],
      childRefreshCount: 0,
      show: false,
      show2: false,
      show3: false,
      reprintTail: '0',
      urgent: 0,
      sku: '',
      filterItemType: 3,
      countryOptions: [
        // {
        //   id: "Mỹ", name: 'Mỹ'
        // },
        // {
        //   id: "Úc", name: 'Úc'
        // },
        // {
        //   id: "Mỹ QT", name: 'Mỹ QT'
        // },
        // {
        //   id: "Úc QT", name: 'Úc QT'
        // },
        // {
        //   id: "Mỹ QT Ch.Âu", name: "Mỹ QT Ch.Âu"
        // }
      ],
      selectedCountries: [],
      selectedWoStatusList: [],
      loading: false,
      selected: {},
      selectAll: 0,
      pages: 0,
      pageSize: 10,
      erroMode: 0,
      columns: [
        {
          id: "idx",
          accessor: "",
          width: 40,
          Cell: row => (
            <div style={{ padding: "10px" }}>{row.index + 1}</div>
          )
        },
        {
          id: "checkbox",
          accessor: "",
          Cell: ({ original }) => {
            return (
              <div style={{ textAlign: "center" }}>
                <input
                  type="checkbox"
                  className="checkbox"
                  checked={this.state.selected[original.id] && this.state.selected[original.id].checked === true}
                  onChange={() => this.toggleRow(original)}
                /></div>
            );
          },
          Header: x => {
            return (
              <input
                type="checkbox"
                className="checkbox"
                checked={this.state.selectAll === 1}
                ref={input => {
                  if (input) {
                    input.indeterminate = this.state.selectAll === 2;
                  }
                }}
                onChange={() => this.toggleSelectAll()}
              />
            );
          },
          sortable: false,
          width: 45
        },
        {
          Header: couterpart.translate('work_order_no'),
          accessor: 'workOrderNo',
          width: 150,
          Cell: row => (
            this.linkToDetails(row)
          )
        }, {
          Header: couterpart.translate('work_order_code'),
          accessor: 'sku',
          filterable: false,
          filterMethod: (filter, row) =>
            row[filter.id].includes(filter.value)
        }, {
          Header: couterpart.translate('shop_pcode'),
          accessor: 'fullPCode',
          filterable: false
        }, {
          Header: couterpart.translate('work_order_urgent_level'),
          accessor: 'isUrgentByCustomer',
          width: 50,
          Cell: row => {
            row.styles['color'] = row.value === 1 ? 'red' : 'black';
            return row.value === 1 ? 'X' : '';
          },
          filterable: false,
          filterMethod: (filter, row) =>
            row[filter.id].includes(filter.value)
        }, {
          Header: couterpart.translate('package_code'),
          accessor: 'shipCode',
          filterable: false,
          width: 100,
          filterMethod: (filter, row) =>
            row[filter.id].includes(filter.value)
        }, {
          Header: 'MT',
          accessor: 'fimg',
          width: 100,
          sortable: false,
          Cell: row => (
            this.fImageRender(row)
          )
        }, {
          Header: 'MS',
          accessor: 'bimg',
          sortable: false,
          width: 200,
          Cell: row => (
            this.bImageRender(row)
          )
        }, {
          Header: couterpart.translate('work_order_color'),
          accessor: 'colorMaterial',
          filterable: false,
          width: 70
        }, {
          Header: couterpart.translate('work_order_size'),
          accessor: 'lengthSize',
          sortable: false,
          filterable: false,
          width: 100
        }, {
          Header: couterpart.translate('work_order_status'),
          accessor: 'status',
          width: 100,
          Cell: props => this.getStatusDescription(props.value)
        }, {
          Header: couterpart.translate('work_order_status_len'),
          accessor: 'lenStatus',
          width: 100,
          Cell: ({ original }) => WorkOrderUtil.getLenStatusDescription2(original)
        },{          
          Header: couterpart.translate('work_order_status_da'),
          accessor: 'daStatus',
          width: 100,
          Cell: ({ original }) => WorkOrderUtil.getDaStatusDescription2(original)
        }, {
          Header: couterpart.translate('order_date'),
          accessor: 'orderDate',
          sortable: false,
          filterable: false,
          width: 120
        }, {
          Header: couterpart.translate('work_order_error_code'),
          accessor: 'errorCode',
          width: 100,
          Cell: props => this.getErrorDescription(props.value)
        }, {
          Header: couterpart.translate('customer_country'),
          accessor: 'shopToCountry',
          width: 70
        }, {
          Header: couterpart.translate('ship_to'),
          accessor: 'shipTo',
          width: 70
        }, {
          Header: couterpart.translate('work_ngay_nhap_lieu'),
          accessor: 'ngayNhapLieu',
          filterable: false,
          width: 120
        }, {
          Header: couterpart.translate('work_order_prod_deadline'),
          accessor: 'prodDeadlineTs',
          filterable: false,
          sortable: true,
          width: 120
        }, {
          Header: couterpart.translate('work_order_worker'),
          accessor: 'workerFullName',
          filterable: false,
          width: 70
        }, {
          Header: couterpart.translate('wo_donmua'),
          accessor: 'donMua',
          filterable: false,
          width: 100
        }, {
          Header: couterpart.translate('wo_hangiaomua'),
          accessor: 'hanGiaoMua',
          filterable: false,
          width: 150
        },{          
          Header: couterpart.translate('work_order_itype'),
          accessor: 'itemType',
          width: 150,
          Cell: props => WorkOrderUtil.getItemTypeDescription(props.value)
        },{
          Header: couterpart.translate('da_ghi_thiep'),
          accessor: 'ghiThiep',
          filterable: false,
          width: 150,
          Cell: ({ original }) => WorkOrderUtil.datGhiThiepDesc(original)    
        }, {
          Header: couterpart.translate('reprint_tail_count'),
          accessor: 'reprintCount',
          width: 140
        }],
      sortBy: 'ID',
      sortType: 'desc',
      ghiThiep: 0
    };
  }

  componentWillUnmount() {
    // fix Warning: Can't perform a React state update on an unmounted component
    this.setState = (state, callback) => {
      return;
    };
  }

  fImageRender(row) {
    if (row.original.fimg === undefined || row.original.fimg === null) {
      return (<></>)
    }
    return (
      <img className="imageBox linkTo" alt="" width={100} height={70} src={`data:image/jpeg;base64,${row.original.fimg}`} name={'F' + row.original.workOrderNo} />
    )
  }

  bImageRender(row) {
    if (row.original.bimg === undefined || row.original.bimg === null) {
      return (<></>)
    }
    return (
      <img className="imageBox linkTo" alt="" width={100} height={70} src={`data:image/jpeg;base64,${row.original.bimg}`} name={'B' + row.original.workOrderNo} />
    )
  }

  toggleRow(row) {
    let newSelected = Object.assign({}, this.state.selected);
    if (newSelected[row.id] === undefined) {
      newSelected[row.id] = { checked: true, status: row.status, shipCode: row.shipCode };
    }

    if (this.state.selected[row.id]) {
      newSelected[row.id].checked = !this.state.selected[row.id].checked;
      newSelected[row.id].status = this.state.selected[row.id].status;
      newSelected[row.id].shipCode = this.state.selected[row.id].shipCode;
    }

    this.setState({
      selected: newSelected,
      selectAll: 2
    }, () => {
      WorkOrderUtil.saveItem('shipOrders.selected', JSON.stringify(this.state.selected));
    });
  }

  toggleSelectAll() {
    const newSelected = Object.assign({}, this.state.selected);
    if (this.state.selectAll === 0 || this.state.selectAll === undefined) {
      this.state.workOrders.forEach(x => {
        if (newSelected[x.id] === undefined) {
          newSelected[x.id] = { checked: true, status: x.status, shipCode: x.shipCode };
        } else {
          newSelected[x.id].checked = true;
          newSelected[x.id].status = x.status;
          newSelected[x.id].shipCode = x.shipCode;
        }
      });
    } else {
      this.state.workOrders.forEach(x => {
        if (newSelected[x.id] === undefined) {
          newSelected[x.id] = { checked: false, status: x.status, shipCode: x.shipCode };
        } else {
          newSelected[x.id].checked = false;
          newSelected[x.id].status = x.status;
          newSelected[x.id].shipCode = x.shipCode;
        }
      });
    }

    this.setState({
      selected: newSelected,
      selectAll: this.state.selectAll === 0 ? 1 : 0
    }, () => {
      WorkOrderUtil.saveItem('shipOrders.selected', JSON.stringify(this.state.selected));
    });
  }

  linkToDetails(row) {
    return (
      <label className="label_link" href="#!" onClick={() => { this.handleEdit(row) }}>{row.original.workOrderNo}</label>
    )
  }

  handleEdit(e) {
    this.setState({
      selectedRow: e.viewIndex,
      workOrderId: e.original.id
    }, () => {
      WorkOrderUtil.saveItem('shipOrders.selectedRow', e.viewIndex);
      if (AuthenticationService.isShipping()) {
        WorkOrderUtil.saveItem("shipOrders.woNo", e.original.workOrderNo);
        this.props.history.push("/shipWorkOrderScan");
      }
    })
  }

  loadCountryMappings() {
    MasterDataService.retrieveCountryMappings().then(data => {
      if (data !== undefined && data !== null && data instanceof Array) {
        let countryOptions = [];
        let addedCountries = {}
        for (let i = 0; i < data.length; i++) {
          let country = data[i].mappedInfo;
          if (addedCountries[country] !== undefined && addedCountries[country] !== null) {
            continue;
          }

          countryOptions.push({
            id: country,
            name: country
          });
          addedCountries[country] = 'Y';
        }
        this.setState({ countryOptions: countryOptions })
      }
    });
  }

  componentDidMount() {
    MasterDataService.retrieveAllStatus().then(data => {
      let statusList = [];

      if (data !== undefined && data !== null) {
        statusList.push({
          id: 0,
          name: 'All'
        });
        for (let i = 0; i < data.length; i++) {
          if (data[i].type !== 2) {
            continue;
          }

          // if (data[i].status !== 45 && data[i].status !== 46 && data[i].status !== 52 && data[i].status !== 44 && data[i].status !== 42 && data[i].status !== 54){
          //   continue;
          // }
          if (data[i].status === 30 || data[i].status === 47) {
            continue;
          }
          statusList.push({
            id: data[i].status,
            name: data[i].statusDescVn
          });
        }
      }

      this.setState({ allStatus: data, statusList: statusList })
    });

    this.loadItems();
    this.loadCountryMappings();

    let fromDate = WorkOrderUtil.getItem("shipOrders.fromDate")
    let toDate = WorkOrderUtil.getItem("shipOrders.toDate")

    const values = queryString.parse(this.props.location.search);
    let numOfMonths = 12;
    if (values !== undefined && values.status !== undefined) {
      numOfMonths = 24;
    }

    if (values === undefined || (values.status === undefined && values.isback === undefined)) {
      sessionStorage.removeItem('shipOrders.woStatus');
    }

    if (values === undefined || (values.status === undefined && values.isback === undefined) || fromDate === null || fromDate === undefined) {
      let backTime = 30 * 24 * 60 * 60 * 1000 * numOfMonths;
      fromDate = new Date(new Date().getTime() - backTime);//1 month
      fromDate = WorkOrderUtil.convertToyyyyMMddhhmmString(fromDate);
    }

    if (toDate === null || toDate === undefined) {
      toDate = new Date();
      toDate = WorkOrderUtil.convertToyyyyMMddhhmmString(toDate);
    }

    // let vm = this;
    let status = WorkOrderUtil.getItem("shipOrders.status");
    let sCountries = WorkOrderUtil.getItem('shipOrders.selectedCountries');
    let countries = [];
    try {
      countries = JSON.parse(sCountries)
    } catch (ec) {

    }

    let swoStatusList = WorkOrderUtil.getItem('shipOrders.selectedWoStatusList');
    let woStatusList = [];
    try {
      woStatusList = JSON.parse(swoStatusList)
    } catch (ec) {

    }

    let deadline = WorkOrderUtil.getItem('shipOrders.deadline');
    if (deadline === undefined || deadline === null) {
      deadline = '0';
    }

    let byDeadline = WorkOrderUtil.getItem('shipOrders.byDeadline');
    let fromDeadlineDate = WorkOrderUtil.getItem('shipOrders.fromDeadlineDate');
    let toDeadlineDate = WorkOrderUtil.getItem('shipOrders.toDeadlineDate');
    let reprintTail = WorkOrderUtil.getItem("shipOrders.reprintTail");
    let includeMau = WorkOrderUtil.getItem("shipOrders.includeMau");

    let filterItemType = WorkOrderUtil.getItem("shipOrders.filterItemType");
    if (filterItemType === undefined || filterItemType === null) {
      filterItemType = '3';
    }

    let page = 0;
    try {
      page = parseInt(WorkOrderUtil.getItem('shipOrders.page'));
      if (isNaN(page)) {
        page = 0;
      }
    } catch (ep) {
      page = 0;
    }

    let pageSize = 10;
    try {
      pageSize = parseInt(WorkOrderUtil.getItem('shipOrders.pageSize'));
      if (isNaN(pageSize)) {
        pageSize = 10;
      }
    } catch (eps) {
      pageSize = 10;
    }

    let sortBy = WorkOrderUtil.getItem('shipOrders.sortBy') ? WorkOrderUtil.getItem('shipOrders.sortBy') : 'ID';
    let sortType = WorkOrderUtil.getItem('shipOrders.sortBy') ? WorkOrderUtil.getItem('shipOrders.sortType') : 'desc';

    let sku = WorkOrderUtil.getItem('shipOrders.sku');
    let errorFilter = WorkOrderUtil.getItem('shipOrders.errorFilter') === null || WorkOrderUtil.getItem('shipOrders.errorFilter') === undefined ? 0 : parseInt(WorkOrderUtil.getItem('shipOrders.errorFilter'));
    let woSubStatus = WorkOrderUtil.getItem('shipOrders.woSubStatus') === null || WorkOrderUtil.getItem('shipOrders.woSubStatus') === undefined ? 0 : parseInt(WorkOrderUtil.getItem('shipOrders.woSubStatus'));
    let urgent = WorkOrderUtil.getItem("shipOrders.urgent");
    let donMuaSearch = WorkOrderUtil.getItem("shipOrders.donMuaSearch");
    let hanGiaoMuaSearch = WorkOrderUtil.getItem("shipOrders.hanGiaoMuaSearch");
    let hanGiaoMuaEndSearch = WorkOrderUtil.getItem("shipOrders.hanGiaoMuaEndSearch");
    let filterGhiThiep = WorkOrderUtil.getItem("shipOrders.filterGhiThiep");
    if (!filterGhiThiep) {
      filterGhiThiep = 0;
    }

    let ghiThiep = WorkOrderUtil.getItem("shipOrders.ghiThiep");
    if (!ghiThiep) {
      ghiThiep = 0;
    }

    this.setState({
      fromDate: fromDate,
      toDate: toDate,
      status: status,
      country: WorkOrderUtil.getItem("shipOrders.shipTo"),
      customer: WorkOrderUtil.getItem("shipOrders.customer"),
      orderNo: WorkOrderUtil.getItem("shipOrders.orderNo"),
      woStatus: WorkOrderUtil.getItem("shipOrders.woStatus"),
      woSubStatus: woSubStatus,
      errorFilter: errorFilter,
      selectedCountries: countries,
      selectedWoStatusList: woStatusList,
      deadline: deadline,
      byDeadline: byDeadline,
      fromDeadlineDate: fromDeadlineDate,
      toDeadlineDate: toDeadlineDate,
      page: page === undefined || page === null ? 0 : page,
      pageSize: pageSize === undefined || pageSize === null ? 10 : pageSize,
      sortBy: sortBy,
      sortType: sortType,
      sku: sku,
      reprintTail: reprintTail,
      includeMau: includeMau,
      filterItemType: filterItemType,
      urgent: urgent,
      donMua: donMuaSearch,
      hanGiaoMua: hanGiaoMuaSearch,
      hanGiaoMuaEnd: hanGiaoMuaEndSearch,
      filterGhiThiep: filterGhiThiep,
      ghiThiep: ghiThiep
    }, () => {
      this.fetchWorkOrdersBy();
    });

  }

  clearSearchInfo() {
    WorkOrderUtil.removeItem("shipOrders.fromDate")
    WorkOrderUtil.removeItem("shipOrders.toDate")
    WorkOrderUtil.removeItem("shipOrders.status")
    WorkOrderUtil.removeItem("shipOrders.shipTo")
    WorkOrderUtil.removeItem("shipOrders.customer")
    WorkOrderUtil.removeItem("shipOrders.orderNo")
    WorkOrderUtil.removeItem("shipOrders.woStatus")
    WorkOrderUtil.removeItem("shipOrders.woSubStatus")
    WorkOrderUtil.removeItem("shipOrders.errorFilter")
    WorkOrderUtil.removeItem("shipOrders.pcode")
    WorkOrderUtil.removeItem("shipOrders.personalization")
    WorkOrderUtil.removeItem('shipOrders.selectedPage')
    WorkOrderUtil.removeItem('shipOrders.selectedRow')
    WorkOrderUtil.removeItem("shipOrders.selectedCountries");
    WorkOrderUtil.removeItem("shipOrders.selectedWoStatusList");

    WorkOrderUtil.removeItem("shipOrders.byDeadline");
    WorkOrderUtil.removeItem("shipOrders.fromDeadlineDate");
    WorkOrderUtil.removeItem("shipOrders.toDeadlineDate");
    WorkOrderUtil.removeItem("shipOrders.deadline");
    WorkOrderUtil.removeItem("shipOrders.page");
    WorkOrderUtil.removeItem("shipOrders.pageSize");
    WorkOrderUtil.removeItem("shipOrders.sortBy");
    WorkOrderUtil.removeItem("shipOrders.sortType");
    WorkOrderUtil.removeItem("shipOrders.reprintTail");
    WorkOrderUtil.removeItem("shipOrders.sku");
    WorkOrderUtil.removeItem("shipOrders.includeMau");
    WorkOrderUtil.removeItem("shipOrders.filterItemType");
    WorkOrderUtil.removeItem("shipOrders.urgent");
    WorkOrderUtil.removeItem("shipOrders.donMuaSearch");
    WorkOrderUtil.removeItem("shipOrders.hanGiaoMuaSearch");
    WorkOrderUtil.removeItem("shipOrders.hanGiaoMuaEndSearch");
    WorkOrderUtil.removeItem("shipOrders.filterGhiThiep");
    WorkOrderUtil.removeItem("shipOrders.ghiThiep");
  }
  saveSearchInfo(fromDate, toDate, status, shipTo, orderNo, woStatus, woSubStatus, pcode, personalization, selectedCountries,
    selectedWoStatusList, byDeadline, fromDeadlineDate, toDeadlineDate, deadline, page, pageSize, sortBy, sortType,
    reprintTail, sku, errorFilter, includeMau, filterItemType, urgent, donMuaSearch, hanGiaoMuaSearch, hanGiaoMuaEndSearch, filterGhiThiep, ghiThiep) {
    WorkOrderUtil.saveItem("shipOrders.fromDate", fromDate);
    WorkOrderUtil.saveItem("shipOrders.toDate", toDate);
    WorkOrderUtil.saveItem("shipOrders.status", status);
    WorkOrderUtil.saveItem("shipOrders.shipTo", shipTo);
    WorkOrderUtil.saveItem("shipOrders.orderNo", orderNo);
    WorkOrderUtil.saveItem("shipOrders.woStatus", woStatus);
    WorkOrderUtil.saveItem("shipOrders.woSubStatus", woSubStatus);
    WorkOrderUtil.saveItem("shipOrders.errorFilter", errorFilter);
    WorkOrderUtil.saveItem("shipOrders.pcode", pcode);
    WorkOrderUtil.saveItem("shipOrders.personalization", personalization);
    WorkOrderUtil.saveItem("shipOrders.selectedCountries", JSON.stringify(selectedCountries));
    WorkOrderUtil.saveItem("shipOrders.selectedWoStatusList", JSON.stringify(selectedWoStatusList));

    WorkOrderUtil.saveItem("shipOrders.deadline", deadline);
    WorkOrderUtil.saveItem("shipOrders.byDeadline", byDeadline);
    WorkOrderUtil.saveItem("shipOrders.fromDeadlineDate", fromDeadlineDate);
    WorkOrderUtil.saveItem("shipOrders.toDeadlineDate", toDeadlineDate);
    WorkOrderUtil.saveItem("shipOrders.page", page);
    WorkOrderUtil.saveItem("shipOrders.pageSize", pageSize);
    WorkOrderUtil.saveItem("shipOrders.sortBy", sortBy);
    WorkOrderUtil.saveItem("shipOrders.sortType", sortType);
    WorkOrderUtil.saveItem("shipOrders.reprintTail", reprintTail);
    WorkOrderUtil.saveItem("shipOrders.sku", sku);
    WorkOrderUtil.saveItem("shipOrders.includeMau", includeMau);
    WorkOrderUtil.saveItem("shipOrders.filterItemType", filterItemType);
    WorkOrderUtil.saveItem("shipOrders.urgent", urgent);
    WorkOrderUtil.saveItem("shipOrders.donMuaSearch", donMuaSearch);
    WorkOrderUtil.saveItem("shipOrders.hanGiaoMuaSearch", hanGiaoMuaSearch);
    WorkOrderUtil.saveItem("shipOrders.hanGiaoMuaEndSearch", hanGiaoMuaEndSearch);
    WorkOrderUtil.saveItem("shipOrders.filterGhiThiep", filterGhiThiep);
    WorkOrderUtil.saveItem("shipOrders.ghiThiep", ghiThiep);
  }

  onFilter() {
    this.clearSearchInfo();
    this.setState({ page: 0, selected: {} });
    this.fetchWorkOrdersBy();
  }

  fetchWorkOrdersBy() {
    let fromDate = this.state.fromDate;
    let toDate = this.state.toDate;

    let byDeadline = this.state.byDeadline;
    let fromDeadlineDate = this.state.fromDeadlineDate;
    let toDeadlineDate = this.state.toDeadlineDate;

    let status = this.state.status;
    let woStatus = this.state.woStatus;
    let shipTo = this.state.shipTo;
    let orderNo = this.state.orderNo;
    let pcode = this.state.pcode;
    let personalization = this.state.personalization
    let isShipped = 0;
    let errorCodes = [];
    if (this.state.woSubStatus === WO_DA_SHIP || this.state.woSubStatus === WO_CHUA_SHIP) {
      isShipped = this.state.woSubStatus;

    } else {
      if (this.state.errorFilter === WO_TOBE_FIXE_LOIXI) {
        errorCodes = LOI_XI_LIST;
      } else if (this.state.errorFilter === WO_TOBE_FIXE_LOI_CATKHAC) {
        errorCodes = LOI_CAT_KHAC_LIST;
      } else if (this.state.errorFilter === WO_TOBE_FIXE_LOITHO) {
        errorCodes = LOI_THO_LIST;
      }
    }

    let deadline = this.state.deadline;
    let selectedCountries = this.state.selectedCountries ? this.state.selectedCountries : []
    let selectedWoStatusList = this.state.selectedWoStatusList ? this.state.selectedWoStatusList : []
    let sortBy = this.state.sortBy;
    let sortType = this.state.sortType

    try {
      this.setState({ spinnerVisible: true, loading: true }, () => {
        this.setState({ workOrders: [] }, () => {

          if (status === undefined || status === null) {
            status = "all";
          }

          if (shipTo === undefined || shipTo === null) {
            shipTo = "all";
          }

          if (pcode === undefined || pcode === null) {
            pcode = "";
          }

          if (orderNo === undefined || orderNo === null) {
            orderNo = "";
          }

          if (personalization === null || personalization === undefined) {
            personalization = ""
          }

          let selectedCountryIds = [];
          if (selectedCountries) {
            for (let i = 0; i < selectedCountries.length; i++) {
              selectedCountryIds.push(selectedCountries[i].id);
            }
          }

          let selectedWoStatusCodes = [];
          let selectedWoErrorCodes = [];
          if (selectedWoStatusList) {
            for (let i = 0; i < selectedWoStatusList.length; i++) {
              selectedWoStatusCodes.push(selectedWoStatusList[i].id);
              if (errorCodes.length > 0) {
                for (let i = 0; i < errorCodes.length; i++) {
                  selectedWoErrorCodes.push(errorCodes[i]);
                }
              }
            }
          }

          // let page = this.state.selectedPage;
          // let pageSize = this.state.pageSize;

          let page = 0;
          try {
            page = parseInt(WorkOrderUtil.getItem('shipOrders.page'));
            if (isNaN(page)) {
              page = 0;
            }
          } catch (ep) {
            page = 0;
          }

          let pageSize = 10;
          try {
            pageSize = parseInt(WorkOrderUtil.getItem('shipOrders.pageSize'));
            if (isNaN(pageSize)) {
              pageSize = 10;
            }
          } catch (eps) {
            pageSize = 10;
          }

          let errorFilter = 0;
          try {
            errorFilter = parseInt(WorkOrderUtil.getItem('shipOrders.errorFilter'));
            if (isNaN(errorFilter)) {
              errorFilter = 0;
            }
          } catch (eps) {
            errorFilter = 0;
          }

          let reprintTail = this.state.reprintTail === '1' ? 1 : 0;
          let sku = this.state.sku;

          let selected = this.state.selected;
          let includeMau = this.state.includeMau;
          let filterItemType = this.state.filterItemType;
          let urgent = this.state.urgent;
          let donMuaSearch = this.state.donMuaSearch;
          let hanGiaoMuaSearch = this.state.hanGiaoMuaSearch;
          let hanGiaoMuaEndSearch = this.state.hanGiaoMuaEndSearch;
          let filterGhiThiep = this.state.filterGhiThiep ? this.state.filterGhiThiep : 0;
          let ghiThiep = this.state.ghiThiep ? this.state.ghiThiep : 0;

          let info = {
            fromDate: fromDate,
            toDate: toDate,
            status: status,
            shipTo: shipTo,
            orderNo: orderNo,
            woStatus: undefined,
            isFull: 0,
            pcode: pcode,
            personalization: personalization,
            shipCode: isShipped,
            countries: selectedCountryIds,
            woStatusList: selectedWoStatusCodes,
            woErrorList: selectedWoErrorCodes,
            deadline: deadline,
            byDeadline: byDeadline,
            fromDeadlineDate: fromDeadlineDate,
            toDeadlineDate: toDeadlineDate,
            page: page === undefined ? 0 : page,
            pageSize: pageSize === undefined ? 10 : pageSize,
            sortBy: sortBy,
            sortType: sortType,
            reprintTail: reprintTail,
            sku: sku,
            includeMau: includeMau,
            filterItemType: filterItemType,
            urgent: urgent,
            donMua: donMuaSearch,
            hanGiaoMua: hanGiaoMuaSearch,
            hanGiaoMuaEnd: hanGiaoMuaEndSearch,
            ghiThiepStatus: filterGhiThiep,
            ghiThiep: ghiThiep
          };

          WorkOrderDataService.findWorkOrderList(info)
            .then(data => {
              if (data.message === undefined && data.data !== undefined && data.data instanceof Array) {
                this.setState({ workOrders: data.data, spinnerVisible: false, loading: false, pages: data.pages, page: page, pageSize: pageSize, selected: selected, selectAll: 0 },
                  () => {
                    this.saveSearchInfo(fromDate, toDate, status, shipTo, orderNo, woStatus, isShipped, pcode, personalization, selectedCountries, 
                    selectedWoStatusList, byDeadline, fromDeadlineDate, toDeadlineDate, deadline, page, pageSize, sortBy, 
                    sortType, reprintTail, sku, errorFilter, includeMau, filterItemType, urgent, donMuaSearch, hanGiaoMuaSearch, hanGiaoMuaEndSearch, filterGhiThiep, ghiThiep);
                  });
              } else {
                this.setState({ workOrders: [], loading: false, pages: 0, page: 0, pageSize: pageSize, selected: selected, selectAll: 0 });
                ToastsStore.error(data.message);
              }
            });
        });
      });
    } catch (e) {
      this.sleep(100).then(() => { this.setState({ spinnerVisible: false }); });
    }
  }

  filterWorkOrdersBy() {
    let fromDate = this.state.fromDate;
    let toDate = this.state.toDate;

    let byDeadline = this.state.byDeadline;
    let fromDeadlineDate = this.state.fromDeadlineDate;
    let toDeadlineDate = this.state.toDeadlineDate;

    let status = this.state.status;
    let woStatus = this.state.woStatus;
    let shipTo = this.state.shipTo;
    let orderNo = this.state.orderNo;
    let pcode = this.state.pcode;
    let personalization = this.state.personalization
    let isShipped = this.state.woSubStatus
    let deadline = this.state.deadline;
    let selectedCountries = this.state.selectedCountries ? this.state.selectedCountries : []
    let selectedWoStatusList = this.state.selectedWoStatusList ? this.state.selectedWoStatusList : []

    let c = this.state.childRefreshCount + 1

    let filterItemType = this.state.filterItemType;
    let urgent = this.state.urgent;
    let filterGhiThiep = this.state.filterGhiThiep ? this.state.filterGhiThiep : 0;
    let ghiThiep = this.state.ghiThiep ? this.state.ghiThiep : 0;

    try {
      this.setState({ spinnerVisible: true }, () => {
        this.setState({ workOrders: [] }, () => {

          if (status === undefined || status === null) {
            status = "all";
          }

          if (shipTo === undefined || shipTo === null) {
            shipTo = "all";
          }

          if (pcode === undefined || pcode === null) {
            pcode = "";
          }

          if (orderNo === undefined || orderNo === null) {
            orderNo = "";
          }

          if (personalization === null || personalization === undefined) {
            personalization = ""
          }

          let selectedCountryIds = [];
          if (selectedCountries) {
            for (let i = 0; i < selectedCountries.length; i++) {
              selectedCountryIds.push(selectedCountries[i].id);
            }
          }

          let selectedWoStatusCodes = [];
          if (selectedWoStatusList) {
            for (let i = 0; i < selectedWoStatusList.length; i++) {
              selectedWoStatusCodes.push(selectedWoStatusList[i].id);
            }
          }

          let info = {
            fromDate: fromDate,
            toDate: toDate,
            status: status,
            shipTo: shipTo,
            orderNo: orderNo,
            woStatus: undefined,
            isFull: 0,
            pcode: pcode,
            personalization: personalization,
            shipCode: isShipped,
            countries: selectedCountryIds,
            woStatusList: selectedWoStatusCodes,
            deadline: deadline,
            byDeadline: byDeadline,
            fromDeadlineDate: fromDeadlineDate,
            toDeadlineDate: toDeadlineDate,
            filterItemType: filterItemType,
            urgent: urgent,
            ghiThiepStatus: filterGhiThiep,
            ghiThiep: ghiThiep
          };

          WorkOrderDataService.searchWorkOrdersBy(info)
            .then(data => {
              this.sleep(100).then(() => { this.setState({ spinnerVisible: false }); });
              if (data.message === undefined) {
                // console.log('[retrieveWorkOrdersBy]', data);
                this.setState({ workOrders: data, selectAll: 0 });
                this.saveSearchInfo(fromDate, toDate, status, shipTo, orderNo, woStatus, isShipped, pcode, personalization, selectedCountries, selectedWoStatusList, 
                byDeadline, fromDeadlineDate, toDeadlineDate, deadline, urgent, filterGhiThiep, ghiThiep);
              } else {
                this.setState({ workOrders: [], selectAll: 0 });
                ToastsStore.error(data.message);
              }
            });
        });
      });
    } catch (e) {
      this.sleep(100).then(() => { this.setState({ spinnerVisible: false }); });
    }
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  handleIncludeMauClick() {
    if (this.state.includeMau === 1) {
      this.setState({ includeMau: 0 }, () => {

      });
    } else {
      this.setState({ includeMau: 1 }, () => {

      });
    }
  }

  handleGhiThiepFlterClick(e) {
    let value = e.target.value;
    this.setState({ filterGhiThiep: value });
  }

  renderGhiThiepFilter() {
    return (
      <>
        <div>
          <div>
            <input type="radio" value="1" onChange={this.handleGhiThiepFlterClick.bind(this)} checked={this.state.filterGhiThiep == 1 ? true : false} /> {couterpart.translate('da_ghi_thiep')}<br/>
            <input type="radio" value="2" onChange={this.handleGhiThiepFlterClick.bind(this)} checked={this.state.filterGhiThiep == 2 ? true : false} /> {couterpart.translate('chua_ghi_thiep')}<br/>
            <input type="radio" value="0" onChange={this.handleGhiThiepFlterClick.bind(this)} checked={this.state.filterGhiThiep == 0 ? true : false} /> {couterpart.translate('all_ghi_thiep')}
          </div>
        </div>
      </>
    );
  }

  doPackage() {
    if ((this.checkSelectedItems() === 1)) {
      alert(couterpart.translate('error_ship_items_empty'));
      return;
    }

    if ((this.checkSelectedItems() === 2)) {
      alert(couterpart.translate('error_ship_items_invalid'));
      return;
    }

    let packageDate = WorkOrderUtil.convertToyyyyMMddhhmmString(new Date());

    this.dialog.show({
      title: couterpart.translate("msg_title_confirm"),
      body: couterpart.translate("msg_package_wo_confirm"),
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          try {
            this.setState({ spinnerVisible: true, show: true, packageDate: packageDate }, () => {
              //Do something here
            });
            this.sleep(100).then(() => { this.setState({ spinnerVisible: false }); });
          } catch (e) {
            this.sleep(100).then(() => { this.setState({ spinnerVisible: false }); });
          }
        })
      ],
      bsSize: 'small',
      onHide: (dialog) => {
        dialog.hide()
        console.log('closed by clicking background.')
      }
    });
  }

  changePackage() {
    if ((this.checkSelectedItems() === 1)) {
      alert(couterpart.translate('error_ship_items_empty'));
      return;
    }

    if ((this.checkSelectedItems() !== 2)) {
      alert(couterpart.translate('error_ship_items_invalid'));
      return;
    }

    let packageDate = WorkOrderUtil.convertToyyyyMMddhhmmString(new Date());

    this.dialog.show({
      title: couterpart.translate("msg_title_confirm"),
      body: couterpart.translate("msg_package_wo_change_confirm"),
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          try {
            this.setState({ spinnerVisible: true, show3: true, packageDate: packageDate }, () => {
              //Do something here
            });
            this.sleep(100).then(() => { this.setState({ spinnerVisible: false }); });
          } catch (e) {
            this.sleep(100).then(() => { this.setState({ spinnerVisible: false }); });
          }
        })
      ],
      bsSize: 'small',
      onHide: (dialog) => {
        dialog.hide()
        console.log('closed by clicking background.')
      }
    });
  }

  doPackageNote() {
    if ((this.checkSelectedItems() === 1)) {
      alert(couterpart.translate('error_ship_items_empty'));
      return;
    }

    this.dialog.show({
      title: couterpart.translate("msg_title_confirm"),
      body: couterpart.translate("msg_package_wo_confirm_note"),
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          try {
            this.setState({ spinnerVisible: true, show2: true }, () => {
              //Do something here
            });
            this.sleep(100).then(() => { this.setState({ spinnerVisible: false }); });
          } catch (e) {
            this.sleep(100).then(() => { this.setState({ spinnerVisible: false }); });
          }
        })
      ],
      bsSize: 'small',
      onHide: (dialog) => {
        dialog.hide()
        console.log('closed by clicking background.')
      }
    });
  }

  savePackageInfo() {
    if (this.state.packageDate === undefined || this.state.packageDate === null || this.state.packageDate.trim().length < 6) {
      alert(couterpart.translate('error_ship_date_invalid'));
      return;
    }

    if (this.state.packageNo === undefined || this.state.packageNo === null || this.state.packageNo.trim().length < 1) {
      alert(couterpart.translate('error_ship_code_invalid'));
      return;
    }

    let selectedItems = [];
    for (let key in this.state.selected) {
      if (this.state.selected[key].checked === true) {
        selectedItems.push(parseInt(key));
      }
    }
    WorkOrderDataService.changeShipping(selectedItems, {
      shipCode: this.state.packageNo.trim(),
      shipDate: this.state.packageDate.trim(),
      shipNote: this.state.packageNote.trim()
    }).then(data => {
      console.log('changeShipping', data);
      this.props.history.push("/shipPackages");
    });
  }

  changePackageInfo() {
    if (this.state.packageDateNew === undefined || this.state.packageDateNew === null || this.state.packageDateNew.trim().length < 6) {
      alert(couterpart.translate('error_ship_date_invalid'));
      return;
    }

    if (this.state.packageNoNew === undefined || this.state.packageNoNew === null || this.state.packageNoNew.trim().length < 1) {
      alert(couterpart.translate('error_ship_code_invalid'));
      return;
    }

    let selectedItems = [];
    for (let key in this.state.selected) {
      if (this.state.selected[key].checked === true) {
        selectedItems.push(parseInt(key));
      }
    }
    WorkOrderDataService.changeShipping(selectedItems, {
      shipCode: this.state.packageNoNew.trim(),
      shipDate: this.state.packageDateNew.trim(),
      shipNote: this.state.packageNoteNew.trim()
    }).then(data => {
      console.log('changeShipping', data);
      this.props.history.push("/shipPackages");
    });
  }

  checkSelectedItems() {
    if ((this.state.selected === undefined) || (this.state.selected === null || this.state.selected.length < 1)) {
      return 1
    }
    let count = 0;
    for (let key in this.state.selected) {
      if (this.state.selected[key].checked === true) {
        let status = this.state.selected[key].status;
        let shipCode = this.state.selected[key].shipCode;
        if (status !== 45 || (status === 45 && shipCode !== undefined && shipCode !== null && shipCode.trim().length > 0)) {
          return 2;
        }
        count++;
      }
    }

    if (count < 1) {
      return 1;
    }
    return 0;
  }

  exportExcel() {
    try {
      if ((this.checkSelectedItems() === 1)) {
        alert(couterpart.translate('error_selected_items_empty'));
        return;
      }

      UserDataService.retrieveNextFilename(DATA_TYPE_SHIPPING).then(res => {

        this.setState({ spinnerVisible: true }, () => {
          let selectedItems = [];
          if ((this.state.selected !== undefined) && (this.state.selected !== null)) {
            for (let key in this.state.selected) {
              if (this.state.selected[key].checked === true) {
                selectedItems.push(parseInt(key));
              }
            }
          }
          // console.log("[selectedItems]: ", selectedItems);
          WorkOrderDataService.exportExcelForShipping(selectedItems, res.filename, res.id).then(data => {
            const downloadUrl = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', res.filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            this.sleep(100).then(() => { this.setState({ spinnerVisible: false }); });
          });
        });
      });
    } catch (e) {
      this.sleep(100).then(() => { this.setState({ spinnerVisible: false }); });
    }
  }

  getStatusDescription(status) {
    if (this.state.allStatus === undefined || this.state.allStatus === null) {
      return status;
    }
    let istatus = parseInt(status);
    let statusInfo = this.state.allStatus.find(x => {
      return x.status === istatus;
    });
    if (statusInfo !== undefined) {
      return statusInfo.statusDescVn;
    }
    return status;
  }

  getErrorDescription(errorCode) {
    return DataUtil.getErrorDescription(errorCode);
  }

  handleFromDateChange(date) {
    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({
      fromDate: sDate
    });
  }

  handlePackageDateChange(date) {
    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({
      packageDate: sDate
    });
  }

  handlePackageNoChange(e) {
    let value = e.target.value;
    this.setState({
      packageNo: value
    });
  }

  handlePackageNoteChange(e) {
    let value = e.target.value;
    this.setState({
      packageNote: value
    });
  }

  handleToDateChange(date) {
    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({
      toDate: sDate
    });
  }

  handleFromDeadlineDateChange(date) {
    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({
      fromDeadlineDate: sDate
    });
  }

  handleToDeadlineDateChange(date) {
    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({
      toDeadlineDate: sDate
    });
  }

  handleStatusChange(e) {
    let value = e.target[e.target.selectedIndex].value;
    this.setState({
      status: value
    });
  }

  handleWoStatusChange(e) {
    let value = e.target[e.target.selectedIndex].value;
    this.setState({
      woStatus: value,
      woSubStatus: 0
    });
  }

  handleWoChangeStatusChange(e) {
    let value = e.target[e.target.selectedIndex].value;
    this.setState({
      woChangedStatus: value
    });
  }

  handleCountryChange(e) {
    let value = e.target[e.target.selectedIndex].value;
    sessionStorage.setItem("shipOrders.shipTo", value)
    this.setState({
      shipTo: value
    });
  }

  handleCustomerChange(e) {
    let value = e.target.value;
    this.setState({
      customer: value
    });
  }

  handleKeyDown(e) {
    if (e.key === 'Enter') {
      this.onFilter()
    }
  }

  handleOrderNoChange(e) {
    if (e.key === 'Enter') {
      this.onFilter()
      return;
    }

    let value = e.target.value;
    this.setState({
      orderNo: value
    });
  }

  handlePcodeChange(e) {
    if (e.key === 'Enter') {
      this.onFilter()
      return;
    }

    let value = e.target.value;
    this.setState({
      pcode: value
    });
  }

  handlePersonalizationChange(e) {
    if (e.key === 'Enter') {
      this.onFilter()
      return;
    }

    let value = e.target.value;
    this.setState({
      personalization: value
    });
  }

  renderStatusList() {
    if (this.state.allStatus === undefined || this.state.allStatus === null) {
      return (<></>);
    }

    return (
      <select onChange={this.handleStatusChange.bind(this)}
        value={this.state.status}>
        <option value="all">{couterpart.translate('workorder_status_all')}</option>
        {this.state.allStatus.filter(y => {
          return y.type === 1;
        }).map(x => <option value={x.status} key={x.status}>{x.statusDescVn}</option>)}
      </select>
    );
  }

  renderWoStatusList() {
    if (this.state.allStatus === undefined || this.state.allStatus === null) {
      return (<></>);
    }

    return (
      <>
        <select onChange={this.handleWoStatusChange.bind(this)}
          value={this.state.woStatus}>
          <option value="all">{couterpart.translate('order_status_all')}</option>
          {this.state.allStatus.filter(y => {
            return y.type === 2;
          }).map(x => <option value={x.status} key={x.status}>{x.statusDescVn}</option>)}
        </select>
      </>
    );
  }

  handleSubStatusClick(e) {
    let value = e.target.value;
    let ivalue = 0;
    try {
      ivalue = parseInt(value);
    } catch (e) {
      ivalue = 0;
    }
    this.setState({ woSubStatus: ivalue });
  }

  handleSelectAllClick() {
    if (this.state.selectAll === '1') {
      this.setState({ selectAll: '0', selectedWoStatusList: [], woSubStatus: undefined });
    } else {
      // let allStattus = this.state.statusList.filter(it => {
      //   return it.id !== 0
      // });
      let allStattus = this.state.statusList;
      this.setState({ selectAll: '1', selectedWoStatusList: allStattus, woSubStatus: undefined });
    }
  }

  handleDeadlineClick(e) {
    let value = e.target.value;
    this.setState({ deadline: value });
  }

  handleByDeadlineClick() {
    if (this.state.byDeadline === '1') {
      this.setState({ byDeadline: '0' });
    } else {
      this.setState({ byDeadline: '1' });
    }
  }

  renderWoSubStatusList() {
    if (this.state.allStatus === undefined || this.state.allStatus === null) {
      return (<></>);
    }

    if (this.state.selectedWoStatusList === undefined || this.state.selectedWoStatusList === null) {
      return (<></>);
    }

    let found = this.state.selectedWoStatusList.find(it => {
      return it.id == 45 || it.id == 46 || it.id == 52;
    });

    if (found === undefined) {
      return (<></>);
    }

    return (
      <>
        <div className="row">
          <div className="col-12">
            <input type="radio" value="1" checked={this.state.woSubStatus === 1 ? true : false} onChange={this.handleSubStatusClick.bind(this)} /> <label> {couterpart.translate('wo_shipped')} </label>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <input type="radio" value="2" checked={this.state.woSubStatus === 2 ? true : false} onChange={this.handleSubStatusClick.bind(this)} /> <label> {couterpart.translate('wo_shipped_not')} </label>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <input type="radio" value="0" checked={this.state.woSubStatus === 0 ? true : false} onChange={this.handleSubStatusClick.bind(this)} /> <label> {couterpart.translate('wo_shipped_all')} </label>
          </div>
        </div>
      </>
    );
  }

  renderDealine() {
    return (
      <>
        <div className="row">
          <div className="col-12">
            <input type="radio" value="1" checked={this.state.deadline === '1' ? true : false} onChange={this.handleDeadlineClick.bind(this)} /> <label> {couterpart.translate('wo_deadline')} </label>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <input type="radio" value="2" checked={this.state.deadline === '2' ? true : false} onChange={this.handleDeadlineClick.bind(this)} /> <label> {couterpart.translate('wo_deadline_no')} </label>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <input type="radio" value="0" checked={this.state.deadline === '0' ? true : false} onChange={this.handleDeadlineClick.bind(this)} /> <label> {couterpart.translate('wo_deadline_all')} </label>
          </div>
        </div>
      </>
    );
  }

  renderWoChangeStatusList() {
    if (this.state.allStatus === undefined || this.state.allStatus === null) {
      return (<></>);
    }

    return (
      <select onChange={this.handleWoChangeStatusChange.bind(this)} className="selectBox2"
        value={this.state.woStatus}>
        <option value="all">{couterpart.translate('order_status_all')}</option>
        {this.state.allStatus.filter(y => {
          return y.type === 2;
        }).map(x => <option value={x.status} key={x.status}>{x.statusDescVn}</option>)}
      </select>
    );
  }

  renderItemList() {
    let options = this.state.items !== undefined ? this.state.items : []
    return (
      <div className="col-2">
        <input type="text" name="font" size="16" className="selectBox3" id="skus"
          list="skus"
          placeholder={couterpart.translate('work_order_code')}
          defaultValue={this.state.sku}
          onChange={this.handleSkuChange.bind(this)} onKeyDown={(e) => { e.persist(); setTimeout(() => { this.handleSkuChange(e) }, 0); }} />
        <datalist id="skus">
          {options.map(x => <option value={x.sku} key={x.sku}>{x.sku}</option>)}
        </datalist>
      </div>
    );
  }

  renderProductList() {
    return (
      <div className="row">
        <div className="col-12">
          <ReactTable
            manual
            NoDataComponent={() => null}
            previousText={"<"}
            nextText={">"}
            page={this.state.page}
            pages={this.state.pages}
            onPageChange={pageIndex => {
              WorkOrderUtil.saveItem('shipOrders.page', pageIndex);
              this.fetchWorkOrdersBy()
            }}
            onPageSizeChange={(pageSize, pageIndex) => {
              WorkOrderUtil.saveItem('shipOrders.page', pageIndex);
              WorkOrderUtil.saveItem('shipOrders.pageSize', pageSize);
              this.fetchWorkOrdersBy()
            }}
            onSortedChange={sorted => {
              console.log(sorted)
              let sortType = this.state.sortType === 'desc' ? 'asc' : 'desc';
              this.setState({
                sortBy: sorted[0].id,
                sortType: sortType
              }, () => {
                this.fetchWorkOrdersBy()
              });
            }}
            data={this.state.workOrders}
            loading={this.state.loading}
            columns={this.state.columns}
            defaultPageSize={10}
            showPageSizeOptions={true}
            pageSizeOptions={[3, 5, 10, 20]}
            getTrProps={(state, rowInfo, column) => {
              if (rowInfo && rowInfo.row) {
                return {
                  onClick: (e) => {
                    this.setState({
                      selectedRow: rowInfo.index,
                      workOrderId: rowInfo.original.id
                    }, () => {
                      WorkOrderUtil.saveItem('shipOrders.selectedRow', this.state.selectedRow);
                    })
                  },
                  style: {
                    background: rowInfo.index === this.state.selectedRow ? '#DCDCDC' : 'white',
                    color: rowInfo.index === this.state.selectedRow ? 'white' : 'black'
                  }
                }
              } else {
                return {}
              }
            }}
          />
        </div>
      </div>
    )
  }

  handleSetStatusChange(e) {
    let value = e.target[e.target.selectedIndex].value;
    this.setState(prevState => ({
      newStatus: value
    }));
  }

  handleWorkOrderNoteChange(e) {
    let newValue = e.target.value;
    this.setState(prevState => ({
      workOrderNote: newValue
    }));
  }

  changeWorkOrdersStatus() {
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleClose2() {
    this.setState({ show2: false });
  }

  onSelect(selectedList, selectedItem) {
    // console.log(selectedList, selectedItem);
    this.setState({
      selectedCountries: selectedList
    });
  }

  onRemove(selectedList, removedItem) {
    this.setState({
      selectedCountries: selectedList
    });
  }

  onStatusSelect(selectedList, selectedItem) {
    if (selectedItem.id === 0) {
      this.handleSelectAllClick()
      return;
    }
    this.setState({
      selectedWoStatusList: selectedList
    });
  }

  onStatusRemove(selectedList, removedItem) {
    if (removedItem.id === 0) {
      this.handleSelectAllClick()
      return;
    }
    this.setState({
      selectedWoStatusList: selectedList
    });
  }

  handleReprintTailClick(e) {
    if (this.state.reprintTail === '1') {
      this.setState({ reprintTail: '0' });
    } else {
      this.setState({ reprintTail: '1' });
    }
  }

  renderReprintTail() {
    return (
      <>
        <input type="checkbox" value="1" checked={this.state.reprintTail === '1' ? true : false} onChange={this.handleReprintTailClick.bind(this)} /> <label> {couterpart.translate('reprint_tail')} </label>
      </>
    );
  }

  handleUrgentClick(e) {
    if (this.state.urgent === '1') {
      this.setState({ urgent: '0' });
    } else {
      this.setState({ urgent: '1' });
    }
  }

  renderUrgent() {
    return (
      <>
        <input type="checkbox" value="1" checked={this.state.urgent === '1' ? true : false} onChange={this.handleUrgentClick.bind(this)} /> <label> {couterpart.translate('filter_urgent')} </label>
      </>
    );
  }

  printTails() {
    try {
      let selectedItems = [];
      if ((this.state.selected !== undefined) && (this.state.selected !== null)) {
        for (let key in this.state.selected) {
          if (this.state.selected[key].checked === true) {
            selectedItems.push(parseInt(key));
          }
        }
      }

      if (selectedItems.length < 1) {
        alert(couterpart.translate('error_selected_items_empty'));
        return;
      }


      this.setState({ spinnerVisible: true }, () => {
        let filename = "InDuoiChuot.xlsx";
        WorkOrderDataService.reprintTails(selectedItems, filename).then(data => {
          this.fetchWorkOrdersBy();
          const downloadUrl = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement('a');
          link.href = downloadUrl;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          link.remove();
          this.sleep(100).then(() => { this.setState({ spinnerVisible: false }); });
          this.setState({ selected: [] });
        });
      });
    } catch (e) {
      this.sleep(100).then(() => { this.setState({ spinnerVisible: false }); });
    }
  }

  loadItems() {
    ItemDataService.retrieveItems().then(data => {
      this.setState({
        items: data
      });
    });
  }

  handleSkuChange(e) {
    var value = e.target.value;
    this.setState(prevState => ({
      sku: value
    }));
  }

  handleClose3() {
    this.setState({ show3: false });
  }

  handlePackageDateNewChange(date) {
    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({
      packageDateNew: sDate
    });
  }

  handlePackageNoNewChange(e) {
    let value = e.target.value;
    this.setState({
      packageNoNew: value
    });
  }

  handlePackageNoteNewChange(e) {
    let value = e.target.value;
    this.setState({
      packageNoteNew: value
    });
  }

  handleFilterSelectChange(e) {
    let value = e.target[e.target.selectedIndex].value;
    this.setState({
      errorFilter: value
    });
  };

  renderErrorFilter() {
    let erroMode = WorkOrderUtil.getItem('shipOrders.errorFilter') === null || WorkOrderUtil.getItem('shipOrders.errorFilter') === undefined ? 0 : parseInt(WorkOrderUtil.getItem('shipOrders.errorFilter'));
    return (
      <>
        <select onChange={this.handleFilterSelectChange.bind(this)} className="select_margin" style={{ width: "100%", marginTo: "10px" }}
          defaultValue={erroMode}>
          <option key="" value=""></option>
          <option key="WO_TOBE_FIXE_LOIXI" value={WO_TOBE_FIXE_LOIXI}>{couterpart.translate('wo_loixi')}</option>
          <option key="WO_TOBE_FIXE_LOITHO" value={WO_TOBE_FIXE_LOITHO}>{couterpart.translate('wo_loi_tho')}</option>
          <option key="WO_TOBE_FIXE_LOI_CATKHAC" value={WO_TOBE_FIXE_LOI_CATKHAC}>{couterpart.translate('wo_loi_catkhac')}</option>
          <option key="WO_TOBE_FIXE_ALL" value={WO_TOBE_FIXE_ALL}>{couterpart.translate('wo_loi_others')}</option>
        </select>&nbsp;&nbsp;
      </>
    );
  }

  handleItemTypeClick(e){
    let value = e.target.value;
    this.setState({ filterItemType: value });
  }

  renderItemTypeFilter() {
    return (
      <>
        <div style={{ marginLeft: "1px" }}>
          <div>
            <label><input type="radio" value="1" onChange={this.handleItemTypeClick.bind(this)} checked={this.state.filterItemType == 1 ? true : false} /> {couterpart.translate('wo_len_da')} </label>&nbsp;&nbsp;
            <label><input type="radio" value="2" onChange={this.handleItemTypeClick.bind(this)} checked={this.state.filterItemType == 2 ? true : false} /> {couterpart.translate('wo_normal')} </label>
            <label><input type="radio" value="3" onChange={this.handleItemTypeClick.bind(this)} checked={this.state.filterItemType == 3 ? true : false} /> {couterpart.translate('wo_all')} </label>
          </div>
        </div>
      </>
    );
  }

  handleDonMuaSearchChange(e) {
    var value = e.target.value;
    this.setState({
      donMuaSearch: value
    });
  }

  handleHanGiaoMuaSearchChange(date) {
    var sDate = WorkOrderUtil.convertToyyyyMMddString(date);
    this.setState({
      hanGiaoMuaSearch: sDate
    });
  }

  handleHanGiaoMuaEndSearchChange(date) {
    var sDate = WorkOrderUtil.convertToyyyyMMddString(date);
    this.setState({
      hanGiaoMuaEndSearch: sDate
    });
  }

  renderDonMuaSearch() {
    if (!AuthenticationService.isAdmin() && !AuthenticationService.isService() && !AuthenticationService.isDesigner()  && !AuthenticationService.isShipping() && !AuthenticationService.isKhac()){
      return (<></>);
    }
    return(
      <>
        <div className="row">
          <div className="col-12">
            <div className="row">
              <div className="col-12">
                <input type="text" defaultValue={this.state.donMuaSearch} style={{marginTop: '5px'}}  placeholder="Don Mua(XMAS_24)" 
                onChange={this.handleDonMuaSearchChange.bind(this)}/>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div>
                  <DatePicker name="hanGiaoMuaSearch"
                              dateFormat="MM/dd/yyyy"
                              placeholderText={'Han Giao Mua Bat dau'}
                              selected={WorkOrderUtil.convertToDate(this.state.hanGiaoMuaSearch)}
                              onChange={this.handleHanGiaoMuaSearchChange.bind(this)} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div>
                  <DatePicker name="hanGiaoMuaEndSearch"
                              dateFormat="MM/dd/yyyy"
                              placeholderText={'Han Giao Mua Ket thuc'}
                              selected={WorkOrderUtil.convertToDate(this.state.hanGiaoMuaEndSearch)}
                              onChange={this.handleHanGiaoMuaEndSearchChange.bind(this)} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

renderGhiThiepButton() {
    if (!AuthenticationService.isAdmin() && !AuthenticationService.isService() && !AuthenticationService.isShipping()) {
      return (<></>)
    }

    return (
      <button className="myButton"
        onClick={this.toGhiThiep.bind(this)}>
        <MdImportExport color={ICON_COLOR} />
        &nbsp;{couterpart.translate('button_ghi_thiep')}
      </button>
    )
  }

  toGhiThiep() {
    if ((this.checkSelectedItems() === 1)) {
      alert(couterpart.translate('error_selected_items_empty'));
      return;
    }

    this.dialog.show({
      title: couterpart.translate("msg_title_confirm"),
      body: couterpart.translate("msg_to_ghi_thiep_confirm"),
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          try {
            this.setState({ spinnerVisible: true }, () => {
              let selectedItems = [];
              if ((this.state.selected !== undefined) && (this.state.selected !== null)) {
                for (let key in this.state.selected) {
                  if (this.state.selected[key].checked === true) {
                    selectedItems.push(parseInt(key));
                  }
                }
              }

              WorkOrderDataService.toGhiThiep(selectedItems).then(data => {
                this.setState({ childRefreshCount: this.state.childRefreshCount + 1 }, () => {
                  this.sleep(100).then(() => {
                    this.setState(
                      {
                        spinnerVisible: false
                      });
                  });
                  this.fetchWorkOrdersBy();
                });
              });
            });
          } catch (e) {
            this.sleep(100).then(() => {
              this.setState({
                spinnerVisible: false
              });
            });
          }
        })
      ],
      bsSize: 'small',
      onHide: (dialog) => {
        dialog.hide()
        console.log('closed by clicking background.')
      }
    });
  }

  handleGhiThiepClick() {
    if (this.state.ghiThiep == 1) {
      this.setState({ ghiThiep: 0 }, () => {
        
      });
    } else {
      this.setState({ ghiThiep: 1 }, () => {
        
      });
    }
  }

  render() {
    if (!AuthenticationService.isShipping()) {
      return (<div>Unauthorized access.</div>);
    }

    return (
      <div>
        <MenuComponent2 />
        <ToastsContainer store={ToastsStore} position="bottom_center" />
        <br />
        <div className="row">
          <div className="col-4 border-top border-left border-right border-bottom border-light-gray" style={{ padding: '5px' }}>
            <div className="row">
              <div className="col-2">
                <label><b>{couterpart.translate('order_date_from')}</b></label>
              </div>
              <div className="col-3">
                <div className="customDatePickerWidth">
                  <DatePicker name="orderDateFrom"
                    dateFormat="MM/dd/yyyy hh:mm"
                    selected={WorkOrderUtil.convertToDate(this.state.fromDate)}
                    onChange={this.handleFromDateChange.bind(this)} />
                </div>
              </div>
              <div className="col-2"><label><b>{couterpart.translate('order_date_to')}</b></label></div>
              <div className="col-3">
                <div className="customDatePickerWidth">
                  <DatePicker name="orderDateTo"
                    dateFormat="MM/dd/yyyy hh:mm"
                    selected={WorkOrderUtil.convertToDate(this.state.toDate)}
                    onChange={this.handleToDateChange.bind(this)} />
                </div>
              </div>
            </div>
          </div>
          <div className="col-4 border-top border-left border-right border-bottom border-light-gray" style={{ padding: '5px' }}>
            <div className="row">
              <div className="col-3">
                <input type="checkbox" value="1" checked={this.state.byDeadline === '1' ? true : false} onChange={this.handleByDeadlineClick.bind(this)} /> <label> {couterpart.translate('wo_by_deadline')} </label>
              </div>
              <div className="col-2">
                <label><b>{couterpart.translate('order_date_from')}</b></label>
              </div>
              <div className="col-2">
                <div className="customDatePickerWidth">
                  <DatePicker name="orderDateFrom"
                    dateFormat="MM/dd/yyyy hh:mm"
                    selected={WorkOrderUtil.convertToDate(this.state.fromDeadlineDate)}
                    onChange={this.handleFromDeadlineDateChange.bind(this)} /></div>
              </div>
              <div className="col-2"><label><b>{couterpart.translate('order_date_to')}</b></label></div>
              <div className="col-2">
                <div className="customDatePickerWidth">
                  <DatePicker name="orderDateTo"
                    dateFormat="MM/dd/yyyy hh:mm"
                    selected={WorkOrderUtil.convertToDate(this.state.toDeadlineDate)}
                    onChange={this.handleToDeadlineDateChange.bind(this)} />
                </div>
              </div>
            </div>
          </div>
          <div className="col-2">
            {this.renderItemList()}
          </div>
          <div className="col-2">
            <div className="row">
              <div className="col-4"><label><b>{couterpart.translate('work_order_country')}</b></label>:</div>
              <div className="col-8">
                <Multiselect
                  options={this.state.countryOptions}
                  selectedValues={this.state.selectedCountries}
                  onSelect={this.onSelect.bind(this)}
                  onRemove={this.onRemove.bind(this)}
                  displayValue="name"
                  showCheckbox={true}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row">&nbsp;</div>
        <div className="row">
          <div className="col-2">
            <div className="row">
              <div className="col-12">
                <label><b>{couterpart.translate('work_orders')}</b></label>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <Multiselect style={{ width: "100%" }}
                  options={this.state.statusList}
                  selectedValues={this.state.selectedWoStatusList}
                  onSelect={this.onStatusSelect.bind(this)}
                  onRemove={this.onStatusRemove.bind(this)}
                  displayValue="name"
                  showCheckbox={true}
                />
              </div>
            </div>
          </div>
          <div className="col-1">{this.renderWoSubStatusList()}</div>
          <div className="col-9">
            <div className="row">
              <div className="col-3">
                <div className="row">
                  <div className="col-6">
                    <input type="text" defaultValue={this.state.orderNo} style={{ width: "100%" }} id="orderNo"
                      placeholder={couterpart.translate('order_no')}
                      onChange={this.handleOrderNoChange.bind(this)} onKeyDown={(e) => { e.persist(); setTimeout(() => { this.handleOrderNoChange(e) }, 0); }} />
                  </div>
                  <div className="col-6">
                    <input type="text" defaultValue={this.state.pcode} style={{ width: "100%", marginBottom: '5px' }} id="pcode"
                      placeholder={couterpart.translate('shop_pcode')}
                      onChange={this.handlePcodeChange.bind(this)} onKeyDown={(e) => { e.persist(); setTimeout(() => { this.handlePcodeChange(e) }, 0); }} />
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    {this.renderErrorFilter()}
                  </div>
                  <div className="col-6">
                    <input type="text" defaultValue={this.state.personalization} style={{ width: "100%" }} id="personalization"
                      placeholder={couterpart.translate('work_order_personalization')}
                      onChange={this.handlePersonalizationChange.bind(this)} onKeyDown={(e) => { e.persist(); setTimeout(() => { this.handlePersonalizationChange(e) }, 0); }} />
                  </div>
                </div>
                <div className='col-12'>                      
                  <input type="checkbox" value={0} checked={this.state.ghiThiep == 1 ? true : false} onChange={this.handleGhiThiepClick.bind(this)} /> &nbsp;{couterpart.translate('filter_ghi_thiep')}
                </div>
              </div>
              <div className="col-2">
                {this.renderDealine()}
              </div>
              <div className="col-2">
                <div className='row'>
                  <div className='col-12'>{this.renderReprintTail()}</div>
                </div>
                <div className='row'>
                  <div className='col-12'>{this.renderUrgent()}</div>
                </div>
                <div className='row'>
                  <div className='col-12'>
                    <input type="checkbox" value={1} checked={this.state.includeMau == 1 ? true : false} onChange={this.handleIncludeMauClick.bind(this)} /> &nbsp;{couterpart.translate('work_order_mau')}
                  </div>
                </div>
              </div>
              <div className="col-2">
                { this.renderDonMuaSearch() }
              </div>
              <div className="col-1">
                { this.renderItemTypeFilter() }
              </div>
              <div className="col-1">
                  {this.renderGhiThiepFilter() }
              </div>
              <div className="col-1">
                <button className="myButton" onClick={this.onFilter.bind(this)} style={{ width: "90%" }}><FaFilter color={ICON_COLOR} />{couterpart.translate('button_filter')}</button>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-1">
            &nbsp;
          </div>
          <div className="col-1">
            <button className="myButton" onClick={this.exportExcel.bind(this)}><MdImportExport color={ICON_COLOR} />&nbsp;{couterpart.translate('button_export')}</button>
          </div>
          <div className="col-2">
            &nbsp;
          </div>
          <div className="col-1">
            <button className="myButton"
              onClick={this.printTails.bind(this)}>
              <MdImportExport color={ICON_COLOR} />
              &nbsp;{couterpart.translate('button_print_tail')}
            </button>
          </div>
          { this.renderGhiThiepButton() }
        </div>
        {this.renderProductList()}

        <Modal show={this.state.show} onHide={this.handleClose.bind(this)} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title>Package</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-4">
                <span className="field_margin">{couterpart.translate('wo_package_date')} : </span>
              </div>
              <div className="col-2">
                <DatePicker name="packageDate" className="field_margin"
                  selected={WorkOrderUtil.convertToDate(this.state.packageDate)}
                  dateFormat="MM/dd/yyyy hh:mm"
                  onChange={this.handlePackageDateChange.bind(this)} />
              </div>
            </div>
            <div className="row">
              <div className="col-4">
                <span className="field_margin">{couterpart.translate('wo_package_no')} : </span>
              </div>
              <div className="col-8">
                <input type="text" name="packageNo" className="inputBox3 field_margin"
                  onChange={this.handlePackageNoChange.bind(this)}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-4">
                <span className="field_margin">{couterpart.translate('wo_package_note')} : </span>
              </div>
              <div className="col-8">
                <input type="text" name="packageNote" className="inputBox3 field_margin"
                  onChange={this.handlePackageNoteChange.bind(this)}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={this.handleClose.bind(this)}>Cancel</Button>
            <Button variant="primary" onClick={this.savePackageInfo.bind(this)}>OK</Button>
          </Modal.Footer>
        </Modal>

        <Modal show={this.state.show2} onHide={this.handleClose2.bind(this)} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title>Package</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-4">
                <span className="field_margin">{couterpart.translate('wo_package_note')} : </span>
              </div>
              <div className="col-8">
                <input type="text" name="packageNote" className="inputBox3 field_margin"
                  onChange={this.handlePackageNoteChange.bind(this)}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={this.handleClose2.bind(this)}>Cancel</Button>
            <Button variant="primary" onClick={this.savePackageInfo.bind(this)}>OK</Button>
          </Modal.Footer>
        </Modal>

        <Modal show={this.state.show3} onHide={this.handleClose3.bind(this)} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title>Đổi Package</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-4">
                <span className="field_margin">{couterpart.translate('wo_package_date')} : </span>
              </div>
              <div className="col-2">
                <DatePicker name="packageDateNew" className="field_margin"
                  selected={WorkOrderUtil.convertToDate(this.state.packageDateNew)}
                  dateFormat="MM/dd/yyyy hh:mm"
                  onChange={this.handlePackageDateNewChange.bind(this)} />
              </div>
            </div>
            <div className="row">
              <div className="col-4">
                <span className="field_margin">{couterpart.translate('wo_package_no')} : </span>
              </div>
              <div className="col-8">
                <input type="text" name="packageNoNew" className="inputBox3 field_margin"
                  onChange={this.handlePackageNoNewChange.bind(this)}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-4">
                <span className="field_margin">{couterpart.translate('wo_package_note')} : </span>
              </div>
              <div className="col-8">
                <input type="text" name="packageNoteNew" className="inputBox3 field_margin"
                  onChange={this.handlePackageNoteNewChange.bind(this)}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={this.handleClose3.bind(this)}>Cancel</Button>
            <Button variant="primary" onClick={this.changePackageInfo.bind(this)}>OK</Button>
          </Modal.Footer>
        </Modal>

        <Spinner size={25} spinnerColor={ICON_COLOR} spinnerWidth={2} visible={this.state.spinnerVisible} />
        <Dialog ref={(component) => { this.dialog = component }} />
      </div>
    )
  }
}
export default withRouter(ShipProductList);